/**
 * Employee Web — `/me/calendar` route (EW-18).
 *
 * Phase 05.2-10. Mounts the new <MeCalendarPage> feature; breadcrumb label
 * resolves via the `calendar` namespace (allowlisted in
 * `BREADCRUMB_NAMESPACES` since Plan 01).
 *
 * Search-param schema validates the optional `view` deep-link override —
 * `?view=list` jumps straight to the agenda, `?view=month` is the default.
 * Future plan can extend the schema to persist chip state in the URL.
 */
import type { JSX } from "react";
import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { MeCalendarPage } from "@linkhr/employee-self-service";

const calendarSearchSchema = z.object({
  view: z.enum(["month", "week", "list"]).optional(),
});

export const Route = createFileRoute("/_auth/me/calendar")({
  staticData: { breadcrumb: { labelKey: "calendar:page.title" } },
  validateSearch: calendarSearchSchema,
  component: MeCalendarRoute,
});

function MeCalendarRoute(): JSX.Element {
  // Honour the `?view=` deep link. The page's switcher only builds month + list
  // (week isn't implemented yet); with no usable `?view=` the page picks its own
  // default (list on phones, month otherwise).
  const { view } = Route.useSearch();
  return <MeCalendarPage {...(view === "list" || view === "month" ? { initialView: view } : {})} />;
}
